export const mapPacketsAndPrices = (packagePrices, selectedPackages, translate) => {
    return packagePrices
        .slice()
        .filter((offer) => selectedPackages.includes(offer.name))
        .map((pkg) => ({
        name: `${translate(`tvcomparison.heading.package.${pkg.name}`)}`
    }));
};
